import axios from 'axios';

const endpoint = process.env.REACT_APP_FRONTEND_GRAPHQL_URL;
const frontendGqlAPI = axios.create({ baseURL: endpoint });

export const makeGraphQLQuery = async ({ query = '', variables = {}, token = '' }) => {
    try {
        const response = await frontendGqlAPI.post('', { query, variables }, {
            headers: { Authorization: token },
        });
        const { data, errors } = response.data || {};
        if (errors?.length || !data) throw new Error('Frontend GraphQL request failed.');
        return { r: data, e: null };
    } catch (error) {
        return { r: null, e: error };
    }
};
